import { render, staticRenderFns } from "./Works.vue?vue&type=template&id=ddde484c&scoped=true&"
import script from "./Works.vue?vue&type=script&lang=js&"
export * from "./Works.vue?vue&type=script&lang=js&"
import style0 from "./Works.vue?vue&type=style&index=0&id=ddde484c&scoped=true&lang=css&"
import style1 from "./Works.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddde484c",
  null
  
)

export default component.exports